<template>
  <div class="CircleLoadingButton">
    <div v-if="isLoading"
         class="loader-wrapper"
         :style="computedMarginsStyle"
    >
      <div class="loader"></div>
    </div>
    <slot v-else></slot>
  </div>
</template>

<script>
export default {
  name: 'CircleLoadingButton',
  props: {
    marginTop: {
      default: 'auto'
    },
    marginBottom: {
      default: 'auto'
    },
    marginLeft: {
      default: 'auto'
    },
    marginRight: {
      default: 'auto'
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    computedMarginsStyle () {
      return {
        marginTop: this.marginTop !== 'auto' ? `${this.marginTop}px` : 'auto',
        marginBottom: this.marginBottom !== 'auto' ? `${this.marginBottom}px` : 'auto',
        marginLeft: this.marginLeft !== 'auto' ? `${this.marginLeft}px` : 'auto',
        marginRight: this.marginRight !== 'auto' ? `${this.marginRight}px` : 'auto'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.loader-wrapper {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
}

.loader {
  width: 20px;
  margin: 1px;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: 0.5em solid $primary;
  border-right: 0.5em solid $primary;
  border-bottom: 0.5em solid $primary;
  border-left: 0.5em solid #ffffff;
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 0.8s infinite linear;
}

.loader,
.loader:after {
  border-radius: 100%;
  width: 3em;
  height: 3em;
}

@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>